import { Helmet } from "react-helmet";
import BreadcrumbComponent from "../../components/BreadcrumbComponent/BreadcrumbComponent";
import { BREADCRUMB_INFORMATIVA_PRIVACY } from "../../utils/BreadcrumbEnums";
import "./InformativePrivacy.scss";
import { APP_NAME } from "../../utils/Constans";

/**
 * @function InformativePrivacy page rendering the privacy policy
 * @returns {JSX.Element}
*/
const InformativePrivacy = () => {
    return (
        <div className="InformativePrivacy">
            <BreadcrumbComponent items={BREADCRUMB_INFORMATIVA_PRIVACY}></BreadcrumbComponent>
            <Helmet>
                <title>{APP_NAME} | Informativa sulla privacy</title>
            </Helmet>
            <div className="InformativePrivacy__title mb-3" tabIndex="0" role="contentinfo">
                <h1>Informativa sulla privacy</h1>
            </div>
            <div className="Cookie__paragrafo" tabIndex="0" role="contentinfo">
                <span className="fw-600">Questo sito non fa uso di cookie di profilazione o di altri strumenti di tracciamento.</span>
            </div>
        </div>

    );
};

export default InformativePrivacy;